import * as PIXI from 'pixi.js';
import ImageElement from './ImageElement';
import { CONSTANTS } from '../../PreviewDisplayConstants';

export default class ImageElementsContainer {

    constructor(stage, zIndex) {
        this.stage = stage;

        this.container = new PIXI.Container();
        this.container.zIndex = zIndex;
        this.container.sortableChildren = true;

        this.stage.addChild(this.container);

        this.imageElements = [];
    }

    update(config) {
        // Videos saved before this feature have no images at all.
        const imageSettings = config.imageElements || [];

        this.matchElementCount(imageSettings.length, config.onTextureLoaded);

        // Positions are measured from the middle of the frame, exactly like the text elements.
        this.container.position.set(CONSTANTS.DEFAULT_MID_X, CONSTANTS.DEFAULT_MID_Y);

        // The settings array is ordered bottom-up like the wave layers, so its index doubles
        // as the stacking order and the topmost list item ends up in front.
        imageSettings.forEach((settings, index) => this.imageElements[index].update(settings, index));

        this.container.sortChildren();
    }

    matchElementCount(count, onTextureLoaded) {
        while (this.imageElements.length < count)
            this.imageElements.push(new ImageElement(this.container, onTextureLoaded));

        while (this.imageElements.length > count)
            this.imageElements.pop().destroy();
    }

    updateStage(stage) {
        this.stage = stage;
        this.stage.addChild(this.container);
    }

    destroy() {
        this.container.destroy({ children: true });
    }
}
